import axios from 'axios';
import { store } from './store';

import { parseISO, format } from 'date-fns';
export const API_URL = process.env.REACT_APP_NODE_ENV === 'development' ? process.env.REACT_APP_API_URL_DEV : process.env.REACT_APP_API_URL_LIVE;
export const ADMIN_URL = process.env.REACT_APP_NODE_ENV === 'development' ? process.env.REACT_APP_ADMIN_PANEL_URL_DEV : process.env.REACT_APP_ADMIN_PANEL_URL_LIVE;


export const max_price = process.env.REACT_APP_MAX_PRICE;

export const apiAxios = axios.create({
    baseURL: API_URL
});

const store_data = JSON.parse(store());
// console.log(store_data)

const getToken = async () => {
    return store_data?.token; // Get the token from the Redux store
};

const getConfig = async () => {
    const token = await getToken();
    // console.log("token", token)
    return {
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
        }
    };
};
const getConfigForm = async () => {
  const token = await getToken();
  return {    
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'multipart/form-data',
    }
  };
};


export const postAPI = async (apiName, data) => {
    const response = await apiAxios.post(`${API_URL}${apiName}`, { ...data }, await getConfig());
    return response.data;
};

export const postAPIForm = async (apiName, data) => {
    const response = await apiAxios.post(`${API_URL}${apiName}`, data, await getConfigForm());
    return response.data;
};

export const getAPI = async (apiName) => {
    const response = await apiAxios.get(`${API_URL}${apiName}`, await getConfig());
    return response.data;
};

export const getAPIThirdParty = async (apiName) => {
    const response = await apiAxios.get(`${apiName}`, await getConfig());
    return response.data;
};

export const getURL = () => {
    return process.env.REACT_APP_NODE_ENV === 'development' ? process.env.REACT_APP_API_URL_DEV : process.env.REACT_APP_API_URL_LIVE;
};

export const formatDate = (dateString) => {
    // const date = parseISO(dateString);
    const date = dateString;
    const day = format(date, 'd');
    const month = format(date, 'MMM');
    const year = format(date, 'yyyy');
    return { day, month, year }
};



export const formatDate2 = (dateString) => {
  if (!dateString || typeof dateString !== 'string') return { day: '', month: '', year: '' };

  const monthArr = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const parts = dateString.split('-');

  if (parts.length !== 3) return { day: '', month: '', year: '' };

  const [year, month, day] = parts;
  const monthIndex = parseInt(month, 10) - 1;
  const monthStr = monthArr[monthIndex] || '';

  return { day, month: monthStr, year };
};


export const convertTo24Hour = (time12h) => {
    const [time, modifier] = time12h.trim().split(' ');
    let [hours, minutes] = time.split(':').map(Number);

    if (modifier.toLowerCase() === 'pm' && hours !== 12) {
        hours += 12;
    } else if (modifier.toLowerCase() === 'am' && hours === 12) {
        hours = 0;
    }

    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
}

// Example
// console.log(convertTo24Hour("2:30 PM")); // "14:30"
// console.log(convertTo24Hour("12:00 AM")); // "00:00"

export const convertTo12Hour = (time24h) => {
    let [hours, minutes] = time24h.split(':').map(Number);
    const modifier = hours >= 12 ? 'PM' : 'AM';

    hours = hours % 12 || 12;

    return `${hours}:${String(minutes).padStart(2, '0')} ${modifier}`;
}

// Example
//   console.log(convertTo12Hour("14:30")); // "2:30 PM"
//   console.log(convertTo12Hour("00:00")); // "12:00 AM"

export const splitISODateTime = (isoString) => {
    if (!isoString || typeof isoString !== 'string') return [null, null];

    const [datePart, timePart] = isoString.split('T');

    const date = datePart; // "2025-05-04"
    const time = timePart ? timePart.split('.')[0] : null; // "14:30:00" (without milliseconds)

    return [date, time];
}

// Example usage
//   const [date, time] = splitISODateTime("2025-05-04T14:30:00");
//   console.log(date); // "2025-05-04"
//   console.log(time); // "14:30:00"
